export const dispAge = (age: number): string => {
  const ageStr = age ? age + '歳' : ''
  return ageStr
}

export const calcAge = (birthDay: string): number => {
  if (!birthDay) {
    return 0
  }
  const birthDate = new Date(birthDay)
  const toDay = new Date()
  const thisYearBirthday = new Date(
    toDay.getFullYear(),
    birthDate.getMonth(),
    birthDate.getDate()
  )
  let age = toDay.getFullYear() - birthDate.getFullYear()
  age = age ? age : null

  return toDay < thisYearBirthday ? age - 1 : age
}

export const getWeekCount = (d: Date) => {
  const n = Math.floor((d.getDate() - d.getDay() + 12) / 7)
  return `第${n}週`
}



// WEBPACK FOOTER //
// ./src/components/pages/report/utils.ts